import http from "@/shared/services/http";
import {LadingParams} from "@/modules/ladings/params";

export const createLading = (data: any) => http.post(`v1/bill-ladings`, data);
export const createLadingExcel = (data: any) => http.post(`v1/bill-ladings/list`, data);
export const updateLadingExcel = (data: any) => http.put(`v1/bill-ladings/update-list`, data);
export const listLading = (params?: LadingParams) => http.get(`v1/bill-ladings`, { params });
export const allLading = (params?: LadingParams) => http.get(`v1/bill-ladings/all`, { params });
export const exportExcelLading = (params?: LadingParams) => http.get(`v1/bill-ladings/exportexcellading`, { params });
export const singleLading = (id: string) => http.get(`v1/bill-ladings/${id}`);
export const updateLading = (id: string, data: any) => http.put(`v1/bill-ladings/${id}`, data);
export const deleteLading = (id: string) => http.delete(`v1/bill-ladings/${id}`);
export const calculateMoneyLading = (data: any) => http.post(`v1/bill-ladings/calculateMoney`, data);
export const singleLadingByCode = (code: string) => http.get(`v1/bill-ladings/search/${code}`);
export const singleLadingCodeJoinRelation = (code) => http.get(`v1/bill-ladings/ladingCode/${code}`);
export const listLadingByRowGuids = (rowGuids: string[]) => http.post(`v1/bill-ladings/by-row-guids`, { rowGuids });
export const listLadingNeedUpdate = (params: any) => http.get(`v1/bill-ladings/list-need-update`, { params });
export const scanLadingNeedUpdate = (ladingCode: any) => http.get(`v1/bill-ladings/scan-need-update/${ladingCode}`);
export const getDetailCostUpdate = (params: any) => http.get(`v1/cost-updates`, { params });
